import React from 'react'
import { Segment, Header, Table, Button, Confirm, Input, Message, Checkbox, Form} from 'semantic-ui-react'
import {connect} from 'react-redux'
import * as actions from '../../utils/actions'
import {adicionarMarca, alterarMarca, alterarOrdemMarca} from '../../utils/noliAPI'
import _ from 'lodash'

const Marcas = (props) => {
  const [loading, setLoading] = React.useState(false)
  const [open, openConfirm] = React.useState(false)
  const [selected, setSelected] = React.useState({})
  const [edited, setEdited] = React.useState({id: 0, descricao: ""})
  const [action, setAction] = React.useState("edit")
  const [marcas, setMarcasList] = React.useState([])
  const [searchVal, searchChange] = React.useState("")
  const [original, setOriginalList] = React.useState([])

  React.useEffect(() => {
    setOriginalList(props.dados_veiculos);
  }, [props.dados_veiculos]);

  const editConfirm = (e, {value}) => {
    setAction("edit")
    setSelected(value)
    setEdited(value)
    openConfirm(true)
  }

  const addConfirm = () => {
    setAction("new")
    setEdited({id: 0, descricao: ""})
    setSelected({})
    openConfirm(true)
  }

  const handleToggle = () => {
    if(action === "order") {
      setAction("edit")
      setMarcasList(original.marcas)
    }
    else setAction("order")
  }

  const submit = () => {
    setLoading(true)
    if(action === "new"){
      const payload = {
        descricao: edited.descricao,
      }
      adicionarMarca(payload).then(res => {
        if(res.status_code === "00"){
          props.sendMessage("Marca cadastrada com sucesso", "Sucesso", {color:'blue', icon:'check'})
          props.fetchTransportadoresFilters()
        }else props.sendMessage("Houve um erro ao tentar cadastrar", "Erro")
        setLoading(false)
        openConfirm(false)
        clearSearch()
      })
    }else if(action === "edit"){
      let payload = {}
      if(edited.descricao !== selected.descricao) payload.descricao = edited.descricao
      if(Object.keys(payload).length > 0) alterarMarca(payload, selected.id).then(res => {
          if(res.status_code === "00"){
            props.sendMessage("Marca alterada com sucesso", "Sucesso", {color:'blue', icon:'check'})
            props.fetchTransportadoresFilters()
          }else props.sendMessage("Houve um erro ao tentar alterar", "Erro")
          setLoading(false)
        })
        else(setLoading(false))
        openConfirm(false)
        clearSearch()
    }
  }

  const confirmButton = () => {
    if(action === "edit")
      return <Button
        primary
        content="Alterar"
        disabled={edited.descricao==="" || descricoes.indexOf(edited.descricao.toLowerCase()) !== -1}
        onClick={submit}
      />
    else if(action === "new")
      return <Button
        primary
        content="Adicionar novo"
        disabled={edited.descricao==="" || descricoes.indexOf(edited.descricao.toLowerCase()) > -1}
        onClick={submit}
      />
  }

  const descricoes = props.dados_veiculos ? props.dados_veiculos.marcas.map(c=> c.descricao.toLowerCase()) : []

  const handleSearch = (e, {value}) => {
    searchChange(value)
    const re = new RegExp(_.escapeRegExp(value), 'i')
    const isMatch = (result) => re.test(result.descricao)
    setMarcasList(_.filter(props.dados_veiculos.marcas, isMatch))
  }

  const clearSearch = () => {
    searchChange("")
    setMarcasList([])
  }

  const list = marcas.length > 0 ? marcas : props.dados_veiculos && searchVal==="" ? props.dados_veiculos.marcas : []

  const moveMarca = (oldIndex, positions) => {
    const newIndex = oldIndex + positions
    const toMove = list[oldIndex]
    let newMarca = [...list]
    newMarca.splice(oldIndex, 1)
    newMarca.splice(newIndex, 0, toMove)
    setMarcasList(newMarca.map((end, i)=> {return {...end, ordem:i+1}}))
  }

  const saveNewOrder = () => {
    const payload = {ordem: list.map((m,i) => {return {id: m.id, ordem: i+1}})}
    alterarOrdemMarca(payload)
    .then(res => {
      setAction("new")
      if(res.status_code === "00"){
        props.sendMessage("Ordens de Marcas alteradas com sucesso!", "Sucesso", {color:'blue', icon:'check'})
        props.fetchTransportadoresFilters()
      }else props.sendMessage("Houve um erro ao tentar alterar ordens", "Erro")
      setLoading(false)
    })
  }

  return (
    <>
      <Segment loading={loading}>
        <Header
          as='h4'
          icon='registered outline'
          content="Editar Marcas"
        />
        <Input
          fluid
          action={<Button icon="x" basic onClick={clearSearch} />}
          style={{marginBottom: 7}}
          onChange={handleSearch}
          value={searchVal}
          placeholder="Busque uma Marca"
        />
        <div className="scrollable-y top-bottom-border" style={{height:"66vh"}}>
          <Table>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>ID</Table.HeaderCell>
                <Table.HeaderCell>Descrição</Table.HeaderCell>
                <Table.HeaderCell textAlign="right">Editar</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              { list.length > 0 ? _.map(list, (t, i) => {
                return (
                  <Table.Row key={t.id + "-" + t.descricao}>
                    <Table.Cell width="1">{t.id}</Table.Cell>
                    <Table.Cell>{t.descricao}</Table.Cell>
                    <Table.Cell width="1" textAlign="right">
                      {action !== "order"
                      ? <Button
                          icon="edit"
                          onClick={editConfirm}
                          color="green"
                          value={t}
                          disabled={!props.user.permissions[props.permission].update}
                        />
                      : <Button.Group >
                        <Button
                          icon="arrow up"
                          disabled={i===0}
                          onClick={()=> moveMarca(i, -1)}
                        />
                        <Button
                          icon="arrow down"
                          disabled={i===list.length-1}
                          onClick={()=> moveMarca(i, 1)}
                        />
                      </Button.Group>
                      }
                    </Table.Cell>
                  </Table.Row>
                )}
              ) : (<Table.Row><Table.Cell colSpan="3" negative>Marca não encontrada</Table.Cell></Table.Row>)
            }
            </Table.Body>
          </Table>
        </div>
        <Form >
          <Form.Group inline style={{marginBottom: 0}}>
            { action !== "order"
              ? <Form.Field
                control={Button}
                type="button"
                icon="add"
                labelPosition="right"
                content="Nova Marca"
                primary
                onClick={addConfirm}
                style={{marginTop: 7}}
                disabled={!props.user.permissions[props.permission].create}
              />
              : <Form.Field
                control={Button}
                type="button"
                icon="save"
                labelPosition="right"
                content="Salvar Ordem"
                color="orange"
                onClick={saveNewOrder}
                style={{marginTop: 7}}
                disabled={_.isEqual(list, original.marcas)}
              />
            }
            <Form.Field
              control={Checkbox}
              toggle
              label="Ordenar"
              checked={action === "order"}
              onChange={handleToggle}
              disabled={!props.user.permissions[props.permission].update}
            />
          </Form.Group>
        </Form>
      </Segment>
      <Confirm
        open={open}
        header={action==="new" ? "Nova Marca" : "Alterar Marca (#" + selected.id + ") " + selected.descricao }
        content={
          <Segment basic loading={loading}>
            {action === "new" && edited.descricao === "" && <Message negative content="A descrição não pode ser vazia" />}
            {action === "new" && edited.descricao !== "" && descricoes.indexOf(edited.descricao.toLowerCase()) > -1 && <Message negative content="Esta marca já existe" />}
            Descrição
            <Input
              value={edited.descricao}
              style={{margin: '7px 0'}}
              onChange={(e, {value}) => setEdited({
                id: selected.id,
                descricao: value
              })}
              fluid
            />
          </Segment>
        }
        onCancel={() => openConfirm(false)}
        confirmButton={confirmButton}
        size="tiny"
      />
    </>
  )
}

const mapStateToProps = ({pageInfo}) => pageInfo

export default connect(mapStateToProps, actions)(Marcas)
